<ngx-mat-color-palette (colorChanged)="picker.select($event)" [color]="picker._selected" [showRGBA]="showRGBA"></ngx-mat-color-palette>